import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/login',
    pathMatch: 'full',
  },
  {
    path: 'login',
    loadComponent: () =>
      import('./users/login/login.component').then((m) => m.LoginComponent),
  },
  {
    path: 'public-image/:imgURL',
    loadComponent: () =>
      import('./core/components/public-image/public-image.component').then((m) => m.PublicImageComponent),
  },
  {
    path: 'display-pdf/:pdfURL',
    loadComponent: () =>
      import('./core/components/display-pdf/display-pdf.component').then((m) => m.DisplayPdfComponent),
  },
  {
    path: 'forgot-password',
    loadComponent: () =>
      import('./users/forgot-password/forgot-password.component').then((m) => m.ForgotPasswordComponent),
  },
  {
    path: 'admin-template',
    loadComponent: () => import('./admin-template/admin-template.component').then(m => m.AdminTemplateComponent),
    children: [
      {
        path: '',
        redirectTo: 'sliders',
        pathMatch: 'full'
      },
      {
        path: 'dashboard',
        loadComponent: () => import('./dashboard/dashboard.component').then(m => m.DashboardComponent)
      },
      {
        path: 'sliders',
        loadComponent: () => import('./sliders/sliders-list/sliders-list.component').then(m => m.SlidersListComponent)
      },


      {
        path: 'add-company/:id',
        loadComponent: () => import('./companies/add-update-company/add-update-company.component').then(m => m.AddUpdateCompanyComponent)
      },
      {
        path: 'add-company',
        loadComponent: () => import('./companies/add-update-company/add-update-company.component').then(m => m.AddUpdateCompanyComponent)
      },
      {
        path: 'add-country/:id',
        loadComponent: () => import('./countries/add-update-country/add-update-country.component').then(m => m.AddUpdateCountryComponent)
      },
      {
        path: 'add-country',
        loadComponent: () => import('./countries/add-update-country/add-update-country.component').then(m => m.AddUpdateCountryComponent)
      },
      {
        path: 'news',
        loadComponent: () => import('./news/news-list/news-list.component').then(m => m.NewsListComponent)
      },
      {
        path: 'members', children: [
          {
            path: 'countries',
            loadComponent: () => import('./countries/countries-list/countries-list.component').then(m => m.CountriesListComponent)
          },
          {
            path: 'companies',
            loadComponent: () => import('./companies/companies-list/companies-list.component').then(m => m.CompaniesListComponent)
          },
        ]
      },
      {
        path: 'committee', children: [
          {
            path: "league-members",
            loadComponent: () => import('./league-member/league-member-list/league-member-list.component').then((m) => m.LeagueMemberListComponent)
          },
          {
            path: 'league-achievement',
            loadComponent: () => import('./league-achievement/league-achievement-list/league-achievement-list.component').then(m => m.LeagueAchievementListComponent)
          },
          {
            path: 'league-subscription',
            loadComponent: () => import('./league-subscriptions/league-subscription-list/league-subscription-list.component').then(m => m.LeagueSubscriptionListComponent)
          }
        ]
      },
      {
        path: 'Activities', children: [
          {
            path: 'milestone',
            loadComponent: () =>
              import('./milestone/milestone-list/milestone-list.component').then((m) => m.MilestoneListComponent),
          },
          {
            path: 'seminar',
            loadComponent: () => import('./seminar/seminar-list/seminar-list.component').then(m => m.SeminarListComponent)
          },

        ]
      },
      {
        path: 'organization', children: [
          {
            path: 'general-conferences',
            loadComponent: () => import('./general-conferences/general-conferences-list/general-conferences-list.component').then(m => m.GeneralConferencesListComponent)
          },
          {
            path: 'council',
            loadComponent: () =>
              import('./council/council-list/council-list.component').then((m) => m.CouncilListComponent),
          },
          {
            path: 'technical-committees',
            loadComponent: () => import('./technical-committees/technical-committees-list/technical-committees-list.component').then(m => m.TechnicalCommitteesListComponent)
          },
        ]
      },

      {
        path: 'others', children: [
          { path: '', redirectTo: 'general-conferences', pathMatch: 'full' },

          {
            path: 'archived-files',
            loadComponent: () => import('./archived-files/archived-files-list/archived-files-list.component').then(m => m.ArchivedFilesListComponent)
          },
          {
            path: 'conferences',
            loadComponent: () => import('./conferences/conferences-list/conferences-list.component').then(m => m.ConferencesListComponent)
          },
          {
            path: 'inbox-contact-us-list',
            loadComponent: () => import('./inbox-contact-us/inbox-contact-us-list/inbox-contact-us-list.component').then(m => m.InboxContactUsListComponent)
          }
          ,
          {
            path: 'videos',
            loadComponent: () => import('./videos/video-list/video-list.component').then(m => m.VideoListComponent)
          },
          {
            path: 'events',
            loadComponent: () => import('./events/events-list/events-list.component').then(m => m.EventsListComponent)
          },
        ]
      },

      {
        path: 'magazines',
        loadComponent: () => import('./magazines/magazines-list/magazines-list.component').then(m => m.MagazinesListComponent)
      },

      {
        path: 'newsletter-subscription',
        loadComponent: () =>
          import('./newsletter-subscription/newsletter-subscription-list/newsletter-subscription-list.component').then((m) => m.NewsletterSubscriptionListComponent),
      },

      {
        path: 'reports',
        loadComponent: () =>
          import('./reports/reports-list/reports-list.component').then((m) => m.ReportsListComponent),
      },
      {
        path: 'directory',
        loadComponent: () =>
          import('./directory/directory-list/directory-list.component').then((m) => m.DirectoryListComponent),
      },
      {
        path: 'add-directory',
        loadComponent: () =>
          import('./directory/add-update-directory/add-update-directory.component').then((m) => m.AddUpdateDirectoryComponent)
      }
      ,
      {
        path: 'offer-list',
        loadComponent: () =>
          import('./offer/offer-list/offer-list.component').then((m) => m.OfferListComponent)
      }
      ,
      {
        path: 'directory-request-active-user',
        loadComponent: () =>
          import('./directory-request/directory-request-active-user/directory-request-active-user-list/directory-request-active-user-list.component').then((m) => m.DirectoryRequestActiveUserListComponent)
      },
      {
        path: 'directory-request-pending-user',
        loadComponent: () =>
          import('./directory-request/directory-request-pending-user/directory-request-pending-user-list/directory-request-pending-user-list.component').then((m) => m.DirectoryRequestPendingUserListComponent)
      }
      ,
      {
        path: 'add-directory/:id',
        loadComponent: () =>
          import('./directory/add-update-directory/add-update-directory.component').then((m) => m.AddUpdateDirectoryComponent)
      }
      ,
      {
        path: 'directory-country/:id',
        loadComponent: () =>
          import('./directory/directory-country/directory-countries-list/directory-countries-list.component').then((m) => m.DirectoryCountriesListComponent)
      },
      {
        path: 'directory-company/:id',
        loadComponent: () =>
          import('./directory/directory-companies/directory-companies-list/directory-companies-list.component').then((m) => m.DirectoryCompaniesListComponent)
      },
      {
        path: 'directory-product/:id',
        loadComponent: () =>
          import('./directory/directory-products/directory-products-list/directory-products-list.component').then((m) => m.DirectoryProductsListComponent)
      },
      {
        path: 'career',
        loadComponent: () =>
          import('./career/career-list/career-list.component').then((m) => m.CareerListComponent)
      },
      {
        path: 'staff',
        loadComponent: () =>
          import('./staff/staff-list/staff-list.component').then((m) => m.StaffListComponent)
      },
      {
        path: 'add-staff',
        loadComponent: () =>
          import('./staff/add-update-staff/add-update-staff.component').then((m) => m.AddUpdateStaffComponent)
      },
      {
        path: 'update-staff/:staffId',
        loadComponent: () =>
          import('./staff/add-update-staff/add-update-staff.component').then((m) => m.AddUpdateStaffComponent)
      },
      {
        path: 'user-roles',
        loadComponent: () =>
          import('./user-roles/user-roles-list/user-roles-list.component').then((m) => m.UserRolesListComponent)
      },
      {
        path: 'add-role',
        loadComponent: () =>
          import('./user-roles/add-update-role/add-update-role.component').then((m) => m.AddUpdateRoleComponent)
      },
      {
        path: 'update-role/:roleId',
        loadComponent: () =>
          import('./user-roles/add-update-role/add-update-role.component').then((m) => m.AddUpdateRoleComponent)
      }
    ]
  },
  {
    path: "unauthorized",
    loadComponent: () => import('./unauthorized/unauthorized.component').then((m) => m.UnauthorizedComponent)
  }
];
